module.exports = __webpack_public_path__ + "img/Workers.5966f8fa.svg";